// extracted by mini-css-extract-plugin
export default {"lastCTA":"lastCTA_lastCTA__iulna"};